import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'

interface DialogOrderAttributionFailProps {
  onConfirm?: () => void
  onClose?: () => void
  open: boolean
  isConfirmLoading?: boolean
}

export const DialogOrderAttributionFail = (props: DialogOrderAttributionFailProps) => {
  const { onConfirm, onClose, open = false, isConfirmLoading = false } = props

  return (
    <Dialog open={open} onClose={onClose} maxWidth={320}>
      <DialogHeader onClose={onClose}>
        歸戶失敗
      </DialogHeader>
      <DialogContent>
        <Text variant="body" align="center">訂單歸戶失敗，請重新登入後再試。</Text>
        <Text variant="body" align="center">如仍無法解決，請聯繫客服。</Text>
      </DialogContent>
      <DialogActions>
        <Button fullWidth color="primary" onClick={onConfirm} loading={isConfirmLoading}>重新歸戶</Button>
      </DialogActions>
    </Dialog>
  )
}
